import { ENRICHMENT_CATEGORY_TYPE_LIVEVOTING, ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE, ENRICHMENT_CATEGORY_TYPE_VOTE } from 'common-data-handling';
import React from 'react';
import { PollOption } from '../PollOption';

export function EnrichmentPollOption({ ecat, event, i18n, hasOpenVotingSessions }) {
    if (ecat.category == ENRICHMENT_CATEGORY_TYPE_LIVEVOTING) {
        if (!hasOpenVotingSessions) return null;
        return (
            <PollOption
                href={'./livevoting'}
                icon={'img/vote_icon.png'}
                label={event.settings.vote_label || ecat.label || i18n['label.vote']}
            />
        );
    }

    const shouldShow = ecat.open_count > 0 || ecat.visibility == 1;
    if (!shouldShow) return null;

    let icon, backup_label;
    if (ecat.category == ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE) {
        icon = 'img/questionaire_icon.png';
        backup_label = i18n['label.questionaire'];
    } else if (ecat.category == ENRICHMENT_CATEGORY_TYPE_VOTE) {
        icon = 'img/poll_icon.png';
        backup_label = i18n['label.vote'];
    }

    return <PollOption href={'./enrich/' + ecat.category} icon={icon} label={ecat.label || backup_label} />;
}
